<template>
  <div>
    <page-loading :pageLoad="pageLoad"></page-loading>
    <div class="px-4">
      <!-- <v-divider></v-divider>
      <link-preview></link-preview>
      <v-text-field
        auto-grow
        rows="1"
        placeholder="What do you thinking about this ?"
        hide-details
        @keyup.enter="addComment(item)"
        v-model="text"
        class="mb-4"
      >
        <v-file-input
          v-model="imageFiles"
          v-on:change="onFileChange"
          prepend-icon="mdi-image-outline"
          accept="image/x-png, image/jpeg"
          class="pa-0 ma-0"
          hide-input
          color="primary"
          slot="append"
        >
        </v-file-input>
      </v-text-field> -->
      <v-row>
        <v-col class="d-flex child-flex" cols="4" v-if="n">
          <v-card flat tile class="d-flex img">
            <v-img
              :src="n.src"
              :lazy-src="n.src"
              aspect-ratio="1"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-btn icon @click="deleteImage()" x-small>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-list dense>
      <comment-item
        v-for="comment of showComments"
        :key="comment._id"
        :comment="comment"
        :postId="item._id"
      >
      </comment-item>
    </v-list>
    <v-btn
      class="pa-4 more"
      elevation="0"
      text
      @click="fetchMoreComment()"
      v-if="currentPage < maxPage"
    >
      more
    </v-btn>
  </div>
</template>
<script>
import Vue from "vue";
import Comment from "./Comment";
import LinkPreview from "./LinkPreview";
import PageLoading from "@/components/post/PageLoading.vue";
export default {
  props: ["item", "increaseTotalCommented"],
  components: {
    "comment-item": Comment,
    "link-preview": LinkPreview,
    "page-loading": PageLoading,
  },
  data: () => ({
    // url: "https://api.nerdof.com/api",
    text: "",
    liked: false,
    currentPage: 1,
    maxPage: 0,
    lastFetch: 0,
    showComments: [],
    imageFiles: [],
    imageForCreatePost: [],
    list: [],
    imageUploadId: [],
    n: undefined,
    pageLoad: false,
  }),
  mounted() {
    this.eventShowComment();
  },
  methods: {
    deleteImage() {
      this.n = undefined;
      this.imageForCreatePost = [];
      this.imageFiles = undefined;
    },
    async onFileChange(files) {
      this.pageLoad = true;
      await this.uploadFile(files);
      this.pageLoad = false;
      // this.successUpload = false;
      // let totalFiles;
      // totalFiles = files.length;
      // let resultImg;
      // if (this.list.length + totalFiles > 20) {
      //   resultImg = 20 - this.list.length;
      //   this.warnnig(
      //     `คุณสามารถอัพโหลดรูปภาพได้อีก ${resultImg} รูปเท่านั้น กรุณาเลือกรูปใหม่อีกครั้ง`,
      //     "warning"
      //   );
      //   this.successUpload = true;
      //   this.imageFiles = [];
      //   return;
      // }
      // if (totalFiles === 0) {
      //   this.successUpload = true;
      //   return;
      // } else {
      //   for (var i = 0; i < totalFiles; i++) {
      //     // await this.uploadFile(files[i]);
      //   }
      //   this.successUpload = true;
      //   this.imageFiles = [];
      // }
    },
    async uploadFile(file) {
      // this.showUploadPercent = true;
      let formData = new FormData();
      formData.append("fileupload", file);
      formData.append("title", file.name);
      await Vue.axios
        .post(`${this.$store.state.api}/post/uploadfile/image`, formData, {
          ...this.$store.getters.requestHeaders,
          onUploadProgress: function (progressEvent) {
            // this.progressPercent = parseInt(
            //   Math.round((progressEvent.loaded / progressEvent.total) * 100)
            // );
          }.bind(this),
        })
        .then(
          async function (response) {
            await this.imageUploadId.push(response.data.result.url);
            await this.imageForCreatePost.push(response.data.result);
            // await this.oldFileId.push(response.data.result);
            let imgUrl = response.data.result.url;
            await this.list.push({ src: imgUrl });
            this.n = { src: imgUrl };
            // await this.oldFileUrl.push({ src: imgUrl });
          }.bind(this)
        )
        .catch(function (e) {});
    },
    fetchMoreComment() {
      this.currentPage++;
      this.eventShowComment();
    },
    updateItem(res) {
      if (res.data.status) {
        this.item.liked === res.data.result.liked;
        this.item.likes === res.data.result.likes;
        this.liked = res.data.result.liked;
      }
    },
    comments() {
      return this.item.comments || [];
    },
    clear() {
      this.text = "";
      this.deleteImage();
    },
    addComment() {
      this.pageLoad = true;
      let dataCreatePost = {
        idpost: this.item._id,
        text: this.text,
      };
      if (this.imageForCreatePost && this.imageForCreatePost.length > 0) {
        dataCreatePost.image = this.imageForCreatePost[0];
      }
      Vue.axios
        .post(
          `${this.$store.state.api}/postcomment/manage/insert`,
          dataCreatePost,
          this.$store.getters.requestHeaders
        )
        .then((res) => {
          this.increaseTotalCommented();
          this.pageLoad = false;
          this.showComments.unshift(res.data.result);
          this.clear();
        })
        .catch((err) => {
          this.errMsg = err.response.data.message;
        });
    },
    eventShowComment() {
      if (this.currentPage !== this.lastFetch) {
        const postId = this.item._id;
        const url = this.$store.getters.urlQueryParameter(
          `${this.$store.state.api}/postcomment/list`,
          {
            idpost: postId,
            limit: 10,
            page: this.currentPage,
            sort: "created_at",
            sortby: -1,
          }
        );

        Vue.axios
          .get(url, this.$store.getters.requestHeaders)
          .then((res) => {
            if (res.data.status) {
              this.maxPage = res.data.result.maxPage;
              if (res.data.result.maxPage > this.lastFetch) {
                this.lastFetch = this.currentPage;
                this.showComments.push(...res.data.result.data);
              } else {
                this.lastFetch = res.data.result.maxPage;
                this.currentPage = res.data.result.maxPage;
              }
            }
          })
          .catch((err) => {})
          .finally(() => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.more {
  margin: 8px;
  width: calc(100% - 16px);
}
.input-image-custom {
  padding: 0;
  margin: 0;

  .v-input__prepend-outer {
    margin: 0;
  }

  button {
    color: #f97a92 !important;
  }
}

.img {
  position: relative;

  button {
    position: absolute;
    top: 8px;
    right: 8px;
    background: #fff;
  }
}
</style>

<style lang="scss">
.link-preview .ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
